import React, {useEffect, useState} from 'react';
import {PageHeader} from "../../../components/PageHeader";
import RentalRequestAdminListType from "./rentalRequestAdminListType";
import RentalRequestAdminThumbType from "./RentalRequestAdminThumbType";
import {isMobile, toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../hooks/useRequestData";
import {getRequestRentalAdminList} from "../../../api/lifecycle/rental/rentalRequestService";

const RentalRequestAdmin = () => {
    const [listType, setListType] = useState(true);

    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    }

    useEffect(() => {
        if (isMobile) {
            // mobile
            setListType(false);
        }
    }, []);

    const {newData, pageInfo, dataHook} = useRequestData(getRequestRentalAdminList, initDate, "rental_admin");

    return (
        <div className={"common-container"}>
            <PageHeader header={"대여신청관리"}/>
            {listType ?
                <RentalRequestAdminListType data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook} />
                :
                <RentalRequestAdminThumbType />
            }
        </div>
    );
};

export default RentalRequestAdmin;